import axios from 'axios';

export default {
    namespaced: true,
    state: {
        categoriesFound: {},
        merchantsFound: {},
        totalFound: 0,
        loading: false
    },
    mutations: {
        SET_CATEGORIES_FOUND(state, categories) {
            if (categories) {
                state.categoriesFound = categories;
            } else {
                state.categoriesFound = {};
            }
        },
        SET_MERCHANTS_FOUND(state, merchants) {
            if (merchants) {
                state.merchantsFound = merchants;
            } else {
                state.merchantsFound = {};
            }
        },
        SET_TOTAL_FOUND(state, results) {
            let total = 0;
            if (results.category) {
                total += results.category.total;
            }
            if (results.merchant) {
                total += results.merchant.total;
            }
            state.totalFound = total;
        },
        SET_LOADING(state, flag) {
            state.loading = flag;
        }
    },
    actions: {
        loadDropdownResults({ commit }, query) {
            if (!this.state.loading) {
                commit('SET_LOADING', true);
                let serverConfig = {
                    url: '/xapi/search'
                };
                let requestEndpoint = serverConfig.url;
                let requestParams = {
                    query: query
                };

                requestParams.itemType = ['category', 'merchant'];
                axios
                    .get(requestEndpoint, {
                        params: requestParams,
                        paramsSerializer: function(requestParams) {
                            return qs.stringify(requestParams);
                        }
                    })
                    .then(r => r.data)
                    .then(results => {
                        commit('SET_CATEGORIES_FOUND', results.category);
                        commit('SET_MERCHANTS_FOUND', results.merchant);
                        commit('SET_TOTAL_FOUND', results);
                        commit('SET_LOADING', false);
                    })
                    .catch(error => {
                        commit('SET_LOADING', false);
                        commit('API_DATA_FAILURE', error, { root: true });
                    });
            }
        }
    }
};
